<template>
	<div class="paymentResult">
		<div class="big">
			<img class="img1" src="../../../../assets/pay_success.png" />
			<p class="p1">支付成功</p>
			<p class="p2" style="margin-bottom: 0px;margin-bottom: 1rem;">已开通交道发布会员<br>请登录App体验</p>
			<!-- <p class="p2" style="color: #f63c45;" >每周四统一开具电子发票</p> -->
			<div class="div1">
				<p class="p3" @click="sy">返回首页</p>
				<p class="p4" @click="qxx">去App学习</p>
			</div>
			<div class="div2">
				<p class="p5">温馨提示</p>
				<p class="p6">1、订单20日内可开具发票 ，过期无效；</p>
				<p class="p7">2、若需开具发票，请登录交道App，选择</p>
				<p class="p8" style="padding-left: 0.9rem;text-align: left;">我—>缴费记录—>开发票</p>
			</div>
		</div>
	</div>
</template>
<script>
import request from '@/utils/request';
export default {
	data() {
		return {};
	},
	mounted() {},
	created() {
		document.title = "交道发布";
	},
	methods: {
		sy(){
			// window.location.href="https://upgrade-test.jiaodao11.com/mobile/index.html";
			// window.location.href="http://m-test.jiaodao11.com/openMemberLogin";
			window.location.href="http://m.jiaodao11.com/openMemberLogin";
		},
		qxx(){
			// window.location.href="https://upgrade-test.jiaodao11.com/mobile/index.html";
			window.location.href="https://upgrade.jiaodao11.com/mobile/index.html";
		}
	}
};
</script>

<style rel="stylesheet/scss" lang="scss">
.paymentResult {
	.big {
		width: 100%;
		height: 100%;
		overflow-y: auto;
		display: flex;
		flex-direction: column;
	}
	.img1 {
		display: block;
		width: 0.8rem;
		height: 0.8rem;
		margin: 0 auto;
		margin-top: 2.5rem;
	}
	p {
		text-align: center;
		margin: 0 auto;
	}
	.p1 {
		// line-height: 0.36rem;
		font-size: 0.38rem;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		margin-top: 0.18rem;
		margin-bottom: 0.34rem;
	}
	.p2 {
		// height: 0.32rem;
		font-size: 0.32rem;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		margin-bottom: 1.48rem;
	}
	.div1 {
		width: 70%;
		overflow: hidden;
		margin: 0 auto;
		margin-bottom: 1.5rem;
	}
	.div2 {
		width: 90%;
		height: 3rem;
		margin: 0 auto;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 18px 0px rgba(0, 0, 0, 0.07);
		overflow: hidden;
	}
	.p3 {
		width: 1.9rem;
		height: 0.8rem;
		line-height: 0.8rem;
		text-align: center;
		color: rgba(255, 255, 255, 1);
		font-size: 0.34rem;
		background: rgba(246, 60, 69, 1);
		box-shadow: 0px 1px 18px 0px rgba(151, 0, 7, 0.28);
		border-radius: 40px;
		float: left;
		cursor: pointer;
	}
	.p4 {
		width: 1.9rem;
		height: 0.8rem;
		line-height: 0.8rem;
		text-align: center;
		font-weight: 400;
		color: rgba(246, 60, 69, 1);
		font-size: 0.34rem;
		border: 1px solid rgba(246, 60, 69, 1);
		border-radius: 40px;
		float: right;
		cursor: pointer;
	}
	.p5 {
		width: 2.2rem;
		margin: 0 auto;
		font-size: 0.36rem;
		font-weight: 400;
		color: rgba(253, 196, 0, 1);
		margin-top: 0.36rem;
		margin-bottom: 0.3rem;
		background: url(../../../../assets/ts.png)no-repeat left center;
		padding-left: 0.3rem;
		background-size:0.44rem 0.44rem; 
	}
	.p6,
	.p7,
	.p8 {
		font-size: 0.32rem;
		font-weight: 400;
		color: rgba(153, 153, 153, 1);
		line-height: 0.5rem;
	}
}
</style>
